/*
Simple mapping to support subdomains & different development urls
*/
const serverSelect = () => {
    // const port = window.location.port ? window.location.port : null
    // console.log(window.location)
    if (window.location.port === "3000") {
        return `${window.location.origin.slice(0,-4)}8020`
    } else {
        return window.location.origin
    }
}

export default serverSelect;